import { Context } from 'Context/Context';
import { getGAPageViewsApi } from "../../../Constants"
import React, { useContext, useEffect, useState } from 'react'
import { AdminPage, Panel, BarList, MetricGrid, MetricCard, C } from './AdminAnalyticsUI';
import { Globe, Eye } from 'lucide-react';

// Google Analytics summary: active users by country + page views by page
function AnalyticsPageViews({setActivePanel, activePanel}) {
    const {makeApiCallFunc} = useContext(Context)
    const [gaResp, setGaResp] = useState(null);
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);

    useEffect(()=>{
        makeApiCallFunc(
            getGAPageViewsApi,
            null,
            ({data}) => { setGaResp(data); setLoading(false); },
            (error) => { console.log("GA error", error); setFailed(true); setLoading(false); },
            null,
            false,
            true
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const countries = (gaResp?.country || []).map((c) => ({ label: c.country || 'Unknown', value: parseInt(c.activeUsers) || 0 }));
    const pages = (gaResp?.pageView || []).map((p) => ({ label: p.pagePath || '/', value: parseInt(p.screenPageViews) || 0 }));
    const totalUsers = countries.reduce((a, c) => a + c.value, 0);
    const totalViews = pages.reduce((a, p) => a + p.value, 0);

  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel} title="Web analytics" subtitle="Visitor traffic from Google Analytics.">
      {loading ?
        <div style={{ fontSize: '13px', color: 'rgba(20,33,61,.45)' }}>Loading analytics…</div>
      : failed ?
        <Panel><div style={{ fontSize: '13px', color: 'rgba(20,33,61,.5)' }}>Couldn't load Google Analytics data right now. Please try again later.</div></Panel>
      :
        <>
          <MetricGrid cols={2}>
            <MetricCard icon={<Globe size={16} strokeWidth={2} color={C.navy} />} tile="rgba(20,33,61,.06)" title="Active users" value={totalUsers} desc={'Across ' + countries.length + (countries.length === 1 ? ' country' : ' countries')} />
            <MetricCard icon={<Eye size={16} strokeWidth={2} color={C.brass} />} tile="rgba(138,98,49,.1)" title="Page views" value={totalViews} desc={'Across ' + pages.length + (pages.length === 1 ? ' page' : ' pages')} />
          </MetricGrid>
          <div className='grid grid-cols-1 lg:grid-cols-2' style={{ gap: '22px' }}>
            <Panel title="Active users by country">
              <BarList items={countries} color={C.navy} emptyText="No visitor data yet" maxHeight="440px" />
            </Panel>
            <Panel title="Page views by page">
              <BarList items={pages} emptyText="No page view data yet" maxHeight="440px" />
            </Panel>
          </div>
        </>
      }
    </AdminPage>
  )
}

export default AnalyticsPageViews
